'use client';
import React from 'react';
import { useSession as useAuthSession, signIn } from 'next-auth/react';
import { Button } from '@ui/button';
import { LOGGEDOUT_LINKS } from '@web/molecules/Header/constants';
import { Footer } from '@web/components';
import {
  BaseHeader,
  DiscountBanner,
  LeftMenuLinks,
  CenterMenuLinks,
  LoginMenuLinks,
} from '@web/molecules';
import { useExperiment, USE_WEB_SHOPIFY_AUTH } from '../../experiments';
import { FOOTER_CONTENT } from '../../testing/constants';
import { Redirect } from '../../router';
import {
  StyledLoginContainer,
  LoginContainer,
  ContainerWrapper,
  ButtonContainer,
} from './styles';

export const ShopifyLoginContainer = () => {
  const { data: session, status } = useAuthSession();
  const { value: useShopifyAuth } = useExperiment(USE_WEB_SHOPIFY_AUTH, false);
  const isShopifyAuthenticated = session && status === 'authenticated';

  // only make this page accessible via the feature flag
  if (!useShopifyAuth) {
    return <Redirect to={'/auth/login/'} />;
  }

  if (isShopifyAuthenticated) {
    return <Redirect to={'/account/'} />;
  }

  return (
    <StyledLoginContainer>
      <BaseHeader
        leftSegment={<LeftMenuLinks links={LOGGEDOUT_LINKS} />}
        topSegment={<DiscountBanner />}
        rightSegment={<LoginMenuLinks />}
        centerSegment={<CenterMenuLinks links={LOGGEDOUT_LINKS} />}
        logoUrl="/"
        logoSrText="Ollie logo"
        variant="white"
      />
      <ContainerWrapper>
        <LoginContainer>
          <ButtonContainer>
            <Button onClick={() => signIn('shopify')}>
              Login with Shopify
            </Button>
          </ButtonContainer>
        </LoginContainer>
      </ContainerWrapper>
      <Footer {...FOOTER_CONTENT} />
    </StyledLoginContainer>
  );
};

ShopifyLoginContainer.displayName = 'ShopifyLoginContainer';
